import axios from "../axiosConfig";
import { ENDPOINT_ADD_ROLE, ENDPOINT_REMOVE_ROLE, ENDPOINT_ROLES, ENDPOINT_UPDATE_ROLE } from "../../constants";
import { RoleData } from "./data";

export function retrieveRoles(appId:string) : Promise<any> {
    return new Promise<string>( async (resolve, reject) => {
        axios.get(ENDPOINT_ROLES + "?app=" + appId, {withCredentials:true}).then( res => {
            console.log(res.data)
            
            resolve( res.data)
        })
        .catch( (err) => {
            console.log(err)
            reject(err)
        });
    })
    
}

export function addRole(app:string,role:RoleData) : Promise<string> {
    return new Promise<string>( async (resolve, reject) => {
        axios.post(ENDPOINT_ADD_ROLE, {
            ...role,
            app: app
        }, {withCredentials:true}).then( res => {
            console.log(res.data)
            
            resolve( res.data.Code)
        })
        .catch( (err) => {
            console.log(err)
            reject(err)
        });
    })
    
}

export function removeRole(roleid:string) : Promise<string> {
    return new Promise<string>( async (resolve, reject) => {
        axios.post(ENDPOINT_REMOVE_ROLE + "?id="+roleid, {}, {withCredentials:true} ).then( res => {
            console.log(res.data)
            
            resolve( res.data.Code)
        })
        .catch( (err) => {
            console.log(err)
            reject(err)
        });
    })
    
}

export function updateRole(app:string, desc:string,redirect:string) : Promise<string> {
    return new Promise<string>( async (resolve, reject) => {
        axios.post(ENDPOINT_UPDATE_ROLE, {
            desc:desc,
            app:app,
            redirect:redirect
        }, {withCredentials:true}).then( res => {
            console.log(res.data)
            
            resolve( res.data)
        })
        .catch( (err) => {
            console.log(err)
            reject(err)
        });
    })
    
}